<template>
  <summary-count :title="title" :is-loading="isLoading" :count="count" :change-count="null" :tooltip="tooltipText" @cardClicked="gotoLink()" />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";

export default {
  name: "ActivitySummaryCard",
  components: {
    SummaryCount,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    businessId: {
      type: String,
      required: true,
    },
    activityData: {
      type: Object,
      default: () => ({ count: 0, typeFilterId: null }),
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    activeFilter: {
      type: String,
      default: "today",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    count() {
      return this.activityData.count || 0;
    },
    typeFilterId() {
      return this.activityData.typeFilterId || null;
    },
    tooltipText() {
      if (this.title === "Refill Authorization") {
        return `This represents how many of your Total Activities are Refill Authorizations. These are patients who are nearing the end of their current prescription.`;
      } else if (this.title === "Prescriber Clarifications") {
        return `Prescriber ClarificationsThis represents how many of your Total Activities are Prescriber Clarifications. These are typically patients who have recently started or are in the middle of their current prescription.`;
      } else if (this.title === "Total Activities") {
        return `This represents how many activities are due in total, based on the filter that is selected. This includes activities that are due in the future.`;
      } else if (this.title === "Activities Due") {
        return `This number represents what activities are due both today and before today's date.`;
      }
      return null;
    },
  },
  methods: {
    gotoLink() {
      // Build filter params
      const filterParams = {};

      if (this.typeFilterId) {
        filterParams.typesFilter = [this.typeFilterId];
      }

      if (this.activeFilter !== "pastDue") {
        filterParams.startDate = this.startDate;
        filterParams.endDate = this.endDate;
      }

      filterParams.dateToggle = this.activeFilter;
      let route =
        this.activeFilter === "pastDue" || this.activeFilter === "yesterday"
          ? `/businesses/${this.businessId}/location-todo/past-due`
          : `/businesses/${this.businessId}/location-todo/follow-up`;

      // Serialize filters and open route in new tab
      const queryString = encodeURIComponent(JSON.stringify(filterParams));
      window.open(`${route}?filters=${queryString}`, "_blank");
    },
  },
};
</script>
